<template>
  <div>
    <a-card v-if="userInfo">
      <a-form :form="form" @submit="handleSubmit">
        <a-row :gutter="16">
          <a-col class="gutter-row" :span="12">
            <div class="mb-4">
              <a-form-item label="Name">
                <a-input
                  size="large"
                  value="Tushar"
                  v-decorator="[
                    'name',
                    {
                      rules: [{ required: true, message: 'Please enter name' }],
                      initialValue: userInfo.name || '',
                    },
                  ]"
                  placeholder="Enter name"
                />
              </a-form-item>
            </div>

            <a-row :gutter="16">
              <a-col class="gutter-row" :span="12">
                <div class="mb-4">
                  <a-form-item label="Mobile">
                    <a-input
                      size="large"
                      v-decorator="[
                        'mobile',
                        {
                          rules: [
                            {
                              required: true,
                              message: 'Please enter mobile number',
                            },
                          ],
                          initialValue: userInfo.mobile || '',
                        },
                      ]"
                      placeholder="Enter Mobile Number"
                    >
                      <a-icon
                        slot="prefix"
                        type="mobile"
                        style="color: rgba(0,0,0,.25)"
                      />
                    </a-input>
                  </a-form-item>
                </div>
              </a-col>
              <a-col class="gutter-row" :span="12">
                <div class="mb-4">
                  <a-form-item label="Email">
                    <a-input
                      size="large"
                      type="email"
                      v-decorator="[
                        'email',
                        {
                          rules: [
                            { required: false, message: 'Please enter email' },
                          ],
                          initialValue: userInfo.email || '',
                        },
                      ]"
                      placeholder="Enter Email"
                    />
                  </a-form-item>
                </div>
              </a-col>
            </a-row>

            <a-row :gutter="16" v-if="context === 'editUser'">
              <a-col class="gutter-row" :span="12" v-if="canView('view_role')">
                <div class="mb-4">
                  <a-form-item label="Role">
                    <a-select
                      size="large"
                      @change="riderSelect"
                      show-search
                      :filter-option="filterOption"
                      v-decorator="[
                        'role_id',
                        {
                          rules: [
                            { required: true, message: 'Please select role' },
                          ],
                          initialValue:
                            userInfo.roles &&
                            userInfo.roles.length &&
                            userInfo.roles[0].id
                              ? userInfo.roles[0].id
                              : undefined,
                        },
                      ]"
                      placeholder="Select Role"
                      style="width: 100%"
                    >
                      <template v-for="role in roles">
                        <a-select-option :key="role.id" :value="role.id">
                          {{ role.name }}
                        </a-select-option>
                      </template>
                    </a-select>
                  </a-form-item>
                </div>
              </a-col>
              <a-col class="gutter-row" :span="12">
                <template v-if="canView('view_hub')">
                  <div v-if="canViewHub" class="mb-4">
                    <a-form-item label="Hub">
                      <a-select
                        size="large"
                        show-search
                        :filter-option="filterOption"
                        v-decorator="[
                          'hub_id',
                          {
                            rules: [
                              { required: true, message: 'Please select Hub' },
                            ],
                            initialValue:
                              userInfo.hub && userInfo.hub.id
                                ? userInfo.hub.id
                                : undefined,
                          },
                        ]"
                        placeholder="Select Hub"
                        style="width: 100%"
                      >
                        <template v-for="hub in hubs">
                          <a-select-option :key="hub.id" :value="hub.id">
                            {{ hub.name }}
                          </a-select-option>
                        </template>
                      </a-select>
                    </a-form-item>
                  </div>

                  <div v-if="canViewDevision" class="mb-4">
                    <a-form-item label="Devision">
                      <a-select
                        size="large"
                        show-search
                        :filter-option="filterOption"
                        v-decorator="[
                          'division_id',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please select Devision',
                              },
                            ],
                            initialValue:
                              userInfo.division && userInfo.division.id
                                ? userInfo.division.id
                                : undefined,
                          },
                        ]"
                        placeholder="Select Devision"
                        style="width: 100%"
                      >
                        <template v-for="devision in devisions">
                          <a-select-option
                            :key="devision.id"
                            :value="devision.id"
                          >
                            {{ devision.name_en }}
                          </a-select-option>
                        </template>
                      </a-select>
                    </a-form-item>
                  </div>
                </template>

                <template v-if="canView('view_division')">
                  <div v-if="canViewAreaDevision" class="mb-4">
                    <a-form-item label="Devision">
                      <a-select
                        mode="multiple"
                        size="large"
                        show-search
                        :filter-option="filterOption"
                        @change="selectAreaDevision"
                        v-decorator="[
                          'canViewAreaDevision',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please select Devision',
                              },
                            ],
                            initialValue: initialDevision,
                          },
                        ]"
                        placeholder="Select Devision"
                        style="width: 100%"
                      >
                        <template v-for="devision in devisions">
                          <a-select-option
                            :key="devision.id"
                            :value="devision.id"
                          >
                            {{ devision.name_en }}
                          </a-select-option>
                        </template>
                      </a-select>
                    </a-form-item>
                  </div>
                </template>
              </a-col>

              <a-col
                v-if="
                  canViewArea &&
                    (canView('dropdown_area') || canView('view_area'))
                "
                class="gutter-row"
                :span="12"
              >
                <div class="mb-4">
                  <a-form-item label="Area">
                    <a-select
                      mode="multiple"
                      size="large"
                      show-search
                      :filter-option="filterOption"
                      v-decorator="[
                        'area_ids',
                        {
                          rules: [
                            { required: true, message: 'Please select area' },
                          ],
                          initialValue: initialArea,
                        },
                      ]"
                      placeholder="Select Devision"
                      style="width: 100%"
                    >
                      <template v-for="area in areas">
                        <a-select-option :key="area.id" :value="area.id">
                          {{ area.name }}
                        </a-select-option>
                      </template>
                    </a-select>
                  </a-form-item>
                </div>
              </a-col>
            </a-row>

            <div class="mb-4">
              <a-form-item label="Address">
                <a-textarea
                  v-decorator="[
                    'address',
                    {
                      rules: [
                        { required: true, message: 'Please Enter Address' },
                      ],
                      initialValue: userInfo.address || '',
                    },
                  ]"
                  placeholder="Enter Address"
                  :auto-size="{ minRows: 3, maxRows: 5 }"
                />
              </a-form-item>
            </div>

            <div class="mb-4">
              <a-form-item label="status">
                <a-select
                  size="large"
                  v-decorator="[
                    'status',
                    {
                      rules: [
                        { required: true, message: 'Please select Status' },
                      ],
                      initialValue: userInfo.status,
                    },
                  ]"
                  placeholder="Select Status"
                  style="width: 100%"
                >
                  <a-select-option key="1" :value="1">
                    Active
                  </a-select-option>
                  <a-select-option key="1" :value="0">
                    Inactive
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>

            <a-button
              type="primary"
              class="btn btn-xs"
              size="large"
              html-type="submit"
            >
              Save Changes
            </a-button>
          </a-col>

          <a-col class="gutter-row" :span="12">
            <figure class="text-lg-center">
              <img
                v-if="imageBase64"
                class="img-lg mb-3 img-avatar"
                :src="imageBase64"
                alt="User Photo"
              />
              <img
                v-else-if="userInfo.image_path"
                class="img-lg mb-3 img-avatar"
                :src="userInfo.image_path"
                alt="User Photo"
              />
              <img
                v-else
                class="img-lg mb-3 img-avatar"
                src="../../../assets/imgs/people/User_icon.png"
                alt="User Photo"
              />

              <figcaption>
                <a-upload
                  style="color: red"
                  name="file"
                  @change="profilePreview"
                >
                  <a-button>
                    <a-icon type="upload" /> Click to Upload
                  </a-button>
                </a-upload>
              </figcaption>
            </figure>
          </a-col>
        </a-row>
      </a-form>
    </a-card>
  </div>
</template>

<script>
import {
  USER_UPADTE,
  GET_ROLES,
  HUB_LIST,
  PROFILE_UPDATE,
  DIVISION_LIST,
  AREA_LIST,
} from "../../../script/api";
import { postData, getData } from "../../../script/api-service";
import { alertPop, checkUserPermission } from "../../../script/helper";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export default {
  props: ["userInfo", "userId", "context"],
  data() {
    return {
      imageBase64: "",
      file: "",
      roles: [],
      hubs: [],
      canViewHub: false,
      canViewDevision: false,
      devisions: [],
      canViewAreaDevision: false,
      canViewArea: false,
      areas: [],

      initialDevision: [],
      initialArea: []
    };
  },
  watch: {
    userInfo: function(user) {
      if (user) {
        if (user.roles[0]) {
          this.canViewHub = user.roles[0].hub_dependent ? true : false;
        }

        if (user.roles[0] && user.roles[0].area_dependent) {
          this.canViewAreaDevision = true;
          this.canViewArea = true;
        } else {
          this.canViewAreaDevision = false;
          this.canViewArea = false;
        }

        if (user.area && user.area.length) {
          let devisionIds = [],
              areaIds = [];

          user.area.forEach(area => {
            areaIds.push(area?.area_id?.id);
            devisionIds.push(area?.area_id?.division?.id)
          });

          this.getArea(devisionIds);

          this.initialDevision = devisionIds;
          this.initialArea = areaIds;
        }
      }
    },
  },
  methods: {
    canView(allow) {
      return checkUserPermission(allow);
    },
    async profilePreview({ file }) {
      this.file = file.originFileObj;
      let preview = await getBase64(file.originFileObj);
      this.imageBase64 = preview;
    },
    async getRoles() {
      let res = await getData(GET_ROLES);

      if (res) {
        let masterData = res.data?.data;
        this.roles = masterData || [];
      }
    },
    async getHubs() {
      let res = await getData(HUB_LIST);

      if (res) {
        let masterData = res.data?.data;
        this.hubs = masterData || [];
      }
    },
    async getDevisions() {
      let res = await getData(DIVISION_LIST);

      if (res) {
        let masterData = res.data?.data;
        this.devisions = masterData;
      }
    },
    handleSubmit(e) {
      e.preventDefault();

      this.form.validateFields(async (err, values) => {
        if (!err) {
          let data = new FormData();

          if (this.file) data.append("image", this.file);
          if (values.email !== this.userInfo.email)
            data.append("email", values.email);
          if (values.mobile !== this.userInfo.mobile)
            data.append("mobile", values.mobile);
          if (values.name !== this.userInfo.name)
            data.append("name", values.name);
          if (values.role_id != this.userInfo.role_id)
            data.append("role_id", values.role_id);
          if (values.address !== this.userInfo.address)
            data.append("address", values.address);

          if (values.hub_id && this.canViewHub)
            data.append("hub_id", values.hub_id);
          if (!this.canViewHub) data.append("hub_id", 0);

          if (values.division_id)
            data.append("division_id", values.division_id);

          if (values.area_ids) data.append("area_ids", values.area_ids);

          if (this.userId) data.append("user_id", this.userId);
          data.append("status", values.status);

          let url = USER_UPADTE;

          if (!this.userId) url = PROFILE_UPDATE;

          let res = await postData(url, data);

          if (res) {
            let masterData = res.data.data;
            if (this.userId) this.$emit("updateUser", masterData);
            else this.$emit("updateUser", masterData.user);
            alertPop("success", "User Updated Successfully");
          }
        }
      });
    },
    riderSelect(value) {
      let role = this.roles.find((e) => e.id == value);

      if (role && role.hub_dependent) {
        this.canViewHub = true;
      } else this.canViewHub = false;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    async getArea(devisionId) {
      let res = await getData(AREA_LIST + `?division_ids=${devisionId}`);

      if (res) {
        let masterData = res.data?.data;
        this.canViewArea = true;
        this.areas = masterData;
      }
    },
    selectAreaDevision(value) {
    //   this.form.resetFields("area_ids");
      this.form.setFieldsValue({area_ids: undefined});
      this.getArea(value);
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "store_user" });
  },
  mounted() {
    if (this.canView("view_role")) this.getRoles();
    if (this.canView("view_hub")) this.getHubs();
    if (this.canView("view_division")) this.getDevisions();
  },
};
</script>

<style>
.ant-upload-list {
  display: none;
}
</style>
